import { createTheme, Theme, ThemeOptions } from "@mui/material";

const themeOptions: ThemeOptions = {
  palette: {
    primary: {
      // Purple and green play nicely together.
      main: '#387287',
      contrastText: 'white',
    },
    secondary: {
      // This is green.A700 as hex.
      main: '#11cb5f',
    },
  }
};

export const theme: Theme = createTheme(themeOptions);
